export type BonusItemLine = {
  id: string
  /** Line id from server after save (for Update). */
  serverLineId?: number
  promotionItemId: string
  promotionBatchId: string
  promotionQty: string
  bonusItemId: string
  bonusBatchId: string
  bonusQty: string
}

export type BonusItemRecord = {
  id: string
  branchId: number
  /** Server master id when loaded from API / after save (for PUT Update). */
  serverBonusId?: number
  code: string
  date: string
  warehouseId: number
  warehouseLabel: string
  startDate: string
  endDate: string
  lines: BonusItemLine[]
}

export function newBonusItemLine(): BonusItemLine {
  return {
    id:
      typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID()
        : `ln-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    promotionItemId: '',
    promotionBatchId: '',
    promotionQty: '',
    bonusItemId: '',
    bonusBatchId: '',
    bonusQty: '',
  }
}
